<div class="container-fluid page" *ngIf="!formhide">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp; Video Library
    <div class="export_csv">
      <button
        class="clear_button_export"
        mat-raised-button
        color="primary"
        (click)="openDialogexport()"
      >
        Export
      </button>
      &nbsp;
      <button
        class="clear_button_export"
        mat-raised-button
        color="primary"
        (click)="formPage()"
      >
        Post a New Video
      </button>
    </div>
  </div>
  <div class="page__content shadow p-3">
    <div class="">
      <br />
      <div class="row" style="margin-top: -40px">
        <div class="col-2 topData">
          <p>Total Videos Published</p>
          <p style="font-size: 2rem">{{ avgCount.totalVideo }}</p>
        </div>
        <div class="col-2 topData">
          <p>Published This Month</p>
          <p style="font-size: 2rem">{{ avgCount.totalMonthVideo }}</p>
        </div>
        <div class="col-8 pull-right">
          <!-- <button class="clear_button" (click)="formPage()" mat-raised-button color="primary">Add New
                        Scheme</button> -->
        </div>
      </div>
      <form [formGroup]="filterForm" (ngSubmit)="onSubmit(filterForm)">
        <mat-card>
          <div class="example-header">
            <mat-form-field
              class="full-width-field"
              style="width: 50% !important"
            >
              <input
                matInput
                formControlName="search"
                placeholder="Search"
              /> </mat-form-field
            >&nbsp;&nbsp;

            <button
              type="submit"
              (click)="applyfilter(true)"
              class="btn btn-primary mat-primary search_bar"
            >
              <mat-icon class="search_bar_icon">search</mat-icon>
            </button>

            <hr />

            <mat-form-field>
              <mat-select placeholder="Category" formControlName="category">
                <mat-option
                  *ngFor="let opt of categorydatalist"
                  [value]="opt.categoryId"
                >
                  <img with="20" height="20" [src]="opt.image" />
                  {{ opt.categoryName }}
                </mat-option>
              </mat-select> </mat-form-field
            >&nbsp;&nbsp;

            <mat-form-field>
              <mat-label>Languages</mat-label>
              <mat-select formControlName="languages">
                <mat-option
                  *ngFor="let language of languageList"
                  [value]="language.value"
                >
                  {{ language.viewValue }}
                </mat-option>
              </mat-select> </mat-form-field
            >&nbsp;&nbsp;

            <mat-form-field>
              <input
                matInput
                type="text"
                name="daterange"
                placeholder="Date Range"
                [min]="minDate"
                autocomplete="off"
                [max]="maxDate"
                [alwaysShowCalendars]="true"
                ngxDaterangepickerMd
                formControlName="dateRange"
                [showCustomRangeLabel]="true"
                [ranges]="ranges"
              />
            </mat-form-field>

            <button
              class="btn btn-primary mat-primary clear_button pull-right"
              style="margin-top: 12px"
              type="button"
              (click)="clearForm()"
            >
              Clear Filter
            </button>
            <button
              type="submit"
              style="margin-top: 12px; margin-right: 10px"
              class="btn btn-primary mat-primary pull-right"
              (click)="applyfilter(true)"
            >
              Apply Filter
            </button>

            <mat-chip-list #chipList aria-label="Filter selection">
              <mat-chip
                *ngFor="let filter of matChipArray; let i = index"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(i, filter.tag)"
              >
                {{ filter.name }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>

            <div class="text_filter_data" *ngIf="exportcsvdata">
              <p *ngIf="this.length == 0">
                There's no record found with the given criteria, please try
                again refining your search and filters
              </p>
            </div>
          </div>
        </mat-card>
      </form>

      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="publishDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList">
              {{ VideoList.publishDate }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Title
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList">
              {{ VideoList.title }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="categoryName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="category">
              Category Name
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList" class="category">
              {{ VideoList.categoryName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
              Description
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList">
              {{ VideoList.description }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="videoUrl">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              VideoUrl
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList">
              <a target="_blank" href="{{ VideoList.videoURL }}" class="links"
                >click here</a
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedBy" >
            <mat-header-cell mat-sort-header *matHeaderCellDef class="updated">
              Updated By
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList" class="updated">
              {{ VideoList.updatedBy }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="languages">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
              Languages
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList">
              {{ VideoList.languages }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Action
            </mat-header-cell>
            <mat-cell *matCellDef="let VideoList">
              <div>
                <mat-icon class="colorchange" (click)="edit(VideoList)"
                  >edit</mat-icon
                >&nbsp;&nbsp;&nbsp;
                <mat-icon
                  class="colorchange"
                  (click)="openDialog(VideoList.videoId)"
                  >delete</mat-icon
                >
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <div>
          <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            (page)="getServerData($event)"
            [pageSize]="[10]"
            [pageSizeOptions]="[10, 25, 100]"
            showFirstLastButtons
            aria-label=""
            class="pagination"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!---==============================edit data html =================================================-->
<div class="container-fluid page" *ngIf="formhide">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp;&nbsp;Edit an Updated Video
  </div>
  <div class="example-header" style="height: 557px">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form
          [formGroup]="videoForm"
          (ngSubmit)="onEditSubmit()"
          #myform="ngForm"
        >
          <div class="fulllwidth">
            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Title"
                formControlName="title"
              />
              <mat-error
                style="font-size: 1rem"
                *ngIf="
                  f['title'].errors &&
                  f['title'].errors['required'] &&
                  f['title'] &&
                  myform.submitted
                "
                >Title is required.</mat-error
              >
            </mat-form-field>

            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Video URL"
                formControlName="videoURL"
              />
              <mat-error
                style="font-size: 1rem"
                *ngIf="
                  f['videoURL'].errors &&
                  f['videoURL'].errors['required'] &&
                  f['videoURL'] &&
                  myform.submitted
                "
                >VideoURL is required.</mat-error
              >
            </mat-form-field>

            <div>
              <span>
                <mat-form-field appearance="fill" style="width: 48% !important">
                  <mat-label>Choose a date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="getdate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                    [max]="getToday()"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error
                    style="font-size: 1rem"
                    *ngIf="
                      f['getdate'].errors &&
                      f['getdate'].errors['required'] &&
                      f['getdate'] &&
                      myform.submitted
                    "
                    >Date is required.</mat-error
                  >
                </mat-form-field>
              </span>

              &nbsp;&nbsp;
              <span>
                <mat-form-field appearance="fill" style="width: 48% !important">
                  <mat-label>Category</mat-label>
                  <mat-select placeholder="Category" formControlName="category">
                    <mat-option
                      *ngFor="let opt of categorydatalist"
                      (click)="getcategoryforFilter(opt.categoryID)"
                      [value]="opt.categoryName"
                    >
                      <img with="20" height="20" [src]="opt.image" />
                      {{ opt.categoryName }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    style="font-size: 1rem"
                    *ngIf="
                      f['category'].errors &&
                      f['category'].errors['required'] &&
                      f['category'] &&
                      myform.submitted
                    "
                    >Category is required.</mat-error
                  >
                </mat-form-field>
              </span>
              &nbsp;&nbsp;
            </div>
            <!-- language dropdown -->
            <mat-form-field>
              <mat-label>Languages</mat-label>
              <mat-select placeholder="Languages" formControlName="languages">
                <mat-option
                  *ngFor="let language of languageList"
                  [value]="language?.viewValue"
                >
                  {{ language?.viewValue }}
                </mat-option>
              </mat-select>
              <mat-error
                style="font-size: 1rem"
                *ngIf="
                  f['languages'].errors &&
                  f['languages'].errors['required'] &&
                  f['languages'] &&
                  myform.submitted
                "
                >Languages is required.</mat-error
              >
            </mat-form-field>

            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <button
                  mat-button
                  type="submit"
                  style="color: white"
                  class="submitBtn pull-right"
                >
                  Post
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
